// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"48283363","327":"96281516","404":"9a999fe6","498":"ff108f04","733":"7976ae37"}[chunkId] + ".chunk.js";
};